import React from 'react';
import { Field } from 'formik';

import styles from './workExperienceFormStyles';

import WorkExperienceAutocomplete from './WorkExperienceAutocomplete/workExperienceAutocomplete';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

const { fundTypeNames, aumRangeNames, jobTypes } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const NO_AUM_FUND_TYPES = ['Other', 'Consultant', 'Investment Bank'];

const WorkExperienceForm = ({ isSumzeroAdmin, setFieldValue, values }) => {
  const {
    userProfile: { employerHistories }
  } = values;

  const renderEmployerHistory = (employerHistoryPath, employerHistory) => (
    <div className={styles.employerHistoryMainArea}>
      <div className={styles.employerHistoryRow}>
        <div className={styles.employerHistoryColumn}>
          <WorkExperienceAutocomplete
            name={employerHistoryPath}
            setFieldValue={setFieldValue}
            locked={!isSumzeroAdmin && !!employerHistory.id}
          />
        </div>
        <div className={styles.employerHistoryColumn}>
          <Field
            component={InputField}
            name={employerHistoryPath + '.title'}
            type="select"
            label="Title"
            options={jobTypes}
          />
        </div>
      </div>
      <div className={styles.employerHistoryRow}>
        <div className={styles.employerHistoryColumn}>
          <Field
            component={InputField}
            name={employerHistoryPath + '.employer.fundType'}
            type="select"
            label="Employer Firm Type"
            options={fundTypeNames}
          />
        </div>
        {!NO_AUM_FUND_TYPES.includes(employerHistory.employer.fundType) && (
          <div className={styles.employerHistoryColumn}>
            <Field
              component={InputField}
              name={employerHistoryPath + '.employer.aumRange'}
              type="select"
              label="Employer AUM"
              options={aumRangeNames}
            />
          </div>
        )}
      </div>
      <div className={styles.employerHistoryCurrentEmployer}>
        <Field
          component={SingleCheckboxField}
          name={employerHistoryPath + '.currentEmployer'}
          label="I Am Currently Employed Here"
          onClick={() => {
            setFieldValue(employerHistoryPath + '.primary', false);
          }}
        />
        {employerHistory.currentEmployer ? (
          <Field
            component={SingleCheckboxField}
            name={employerHistoryPath + '.primary'}
            label="Primary Employer"
            onClick={() => {
              employerHistories.forEach((history, idx) => {
                if (history.id !== employerHistory.id) {
                  setFieldValue(`userProfile.employerHistories[${idx}]` + '.primary', false);
                }
              });
            }}
          />
        ) : null}
      </div>
      <div className={styles.employerHistoryRow}>
        <div className={styles.employerHistoryColumn}>
          <Field
            component={InputField}
            name={employerHistoryPath + '.fromDate'}
            type="date"
            label="Start Date"
          />
        </div>
        <div className={styles.employerHistoryColumn}>
          {!employerHistory.currentEmployer && (
            <Field
              component={InputField}
              name={employerHistoryPath + '.toDate'}
              type="date"
              label="End Date"
            />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <AddRemoveForm
      title="Employers"
      attr="userProfile.employerHistories"
      renderItem={renderEmployerHistory}
      itemName="Employer"
      blankItem={{
        employer: {
          name: '',
          fundType: '',
          aumRange: ''
        },
        title: '',
        currentEmployer: false,
        fromDate: null,
        toDate: null,
        primary: false
      }}
      lockExisting
      isSumzeroAdmin={isSumzeroAdmin}
    />
  );
};

export default WorkExperienceForm;
